import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SabisComponents2Module } from '../sabis-components2.module';
import { SabisNgxFilePickerComponent } from './file-picker.component';



@NgModule({
  declarations: [
    SabisNgxFilePickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SabisComponents2Module,

    MatIconModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatButtonModule
  ],
  exports: [
    SabisNgxFilePickerComponent
  ]
})
export class SabisNgxFilePickerModule { }
